// extracted by mini-css-extract-plugin
export default {"topOverlay":"TopOverlay-module__topOverlay_kFA8X","upperLeft":"TopOverlay-module__upperLeft_mMVQ7","upperRight":"TopOverlay-module__upperRight_6IMKS"};